import React, { Component } from 'react'
import dateUtil from '../utils/date.util'

interface ClockProps {}

interface ClockState {
  time: string
}

export default class Clock extends Component<ClockProps, ClockState> {
  interval: number = 0

  constructor (props: ClockProps) {
    super(props)
    this.state = {
      time: this.time
    }
  }

  get time () {
    return dateUtil.currentTime()
  }

  runTimeSetter () {
    this.interval = window.setInterval(() => {
      this.setState({ time: this.time })
    }, 1000)
  }

  componentDidMount () {
    this.runTimeSetter()
  }

  componentWillUnmount () {
    window.clearInterval(this.interval)
  }

  render () {
    return (
      <div className="font-medium text-2xl text-white">
        {this.state.time}
      </div>
    )
  }
}
